import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { createBedBooking, fetchBedStatus } from './bed-status.api';
import type { BedBookingPayload } from './types';

export const bedStatusKeys = {
  all: ['bed-status'] as const,
  dashboard: (search: string) => [...bedStatusKeys.all, { search }] as const,
};

export const useBedStatus = (search: string) => useQuery({
  queryKey: bedStatusKeys.dashboard(search),
  queryFn: () => fetchBedStatus(search),
});

export const useCreateBedBooking = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ bedId, payload }: { bedId: string; payload: BedBookingPayload }) => createBedBooking(bedId, payload),
    onSuccess: async () => queryClient.invalidateQueries({ queryKey: bedStatusKeys.all }),
  });
};
